var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("crear-actualizar-experiencia-trabajo"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("work")]),
          _vm._v(" Experiencia de trabajo")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c(
                "crud-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    url: _vm.url,
                    filters: _vm.filters,
                    "data-graphql": _vm.dataGraphql,
                    graphql: _vm.graphql,
                    initData: _vm.initData
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(items) {
                        return [
                          _c("td", { staticClass: "text-md-center" }, [
                            _vm._v(_vm._s(items.item.institucion))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-md-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.pais ? items.item.pais.pais : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-md-center" }, [
                            _vm._v(_vm._s(items.item.puesto))
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-md-center" }, [
                            _vm._v(
                              _vm._s(
                                _vm
                                  .$moment(items.item.fecha_inicio)
                                  .format("DD/MM/YYYY")
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-md-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.fecha_conclusion
                                  ? _vm
                                      .$moment(items.item.fecha_conclusion)
                                      .format("DD/MM/YYYY")
                                  : ""
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-md-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.id_parametro_tipo_empresa == 1
                                  ? "Publica"
                                  : "Privada"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-center" }, [
                            _vm._v(
                              _vm._s(
                                items.item.personal_dependiente == true
                                  ? "Si"
                                  : "No"
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-md-center" }, [
                            _vm._v(_vm._s(items.item.nro_personas_dependientes))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "nowrap text-xs-center" },
                            [
                              _vm.estado == 1
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "primary", icon: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.crearActualizarExperienciaTrabajo(
                                            items.item
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("edit")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.estado == 1
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: { color: "error", icon: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.deleteItem(
                                            items.item.id,
                                            "experienciaTrabajo"
                                          )
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("delete")])],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", color: "info" },
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.verDocumento(items.item)
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("visibility")])],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _c(
                    "template",
                    { slot: "buttons" },
                    [
                      _c(
                        "v-tooltip",
                        { attrs: { bottom: "" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                slot: "activator",
                                color: "primary",
                                dark: ""
                              },
                              nativeOn: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.crearActualizarExperienciaTrabajo(
                                    {}
                                  )
                                }
                              },
                              slot: "activator"
                            },
                            [
                              _c("v-icon", { attrs: { dark: "" } }, [
                                _vm._v("add")
                              ]),
                              _vm._v(" " + _vm._s(_vm.$t("common.add")))
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [_vm._v("Agregar Experiencia")])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-db77e298", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db77e298","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/components/ExperienciaTrabajo.vue
// module id = null
// module chunks = 